<!-- THE FLOATING XACT PLAYGROUND (XCT-E-12-02).
     CLEAN AND MINIMAL (review, 2026-09-26): the body draws the window's one bar; this frame hosts the body and slides
     the run up over it as a drawer (XCT-E-12-05). -->
<!-- ─── Minimised: a tab DOCKED to the bottom edge on the right (review, 2026-09-26), not a pill left floating wherever
     the window was — it is always in the same place, clear of the page and of the XatBot bubble. ─── -->
@if (isMinimised) {
  <button type="button" class="xf-dock" [class.xf-dock--beside-monitor]="isMonitorDocked" (click)="restore()" title="Open the Xact Playground" data-cy="btn-xact-float-dock">
    <!-- Folded mid-run, the tab is what says this window's run is going (XCT-E-12-05) — the Action Monitor's dot. -->
    @if (hostsRun) {
      <span class="xf-dot"
            role="img"
            [attr.aria-label]="run.status"
            [class.running]="isRunning"
            [class.ok]="run.status === 'completed'"
            [class.bad]="run.status === 'failed'"
            [class.halted]="run.status === 'stopped' || run.status === 'timed-out'"></span>
    }
    <span class="xf-dock-label">{{ pillLabel }}</span>
    <i class="fa-solid fa-chevron-up xf-dock-caret" aria-hidden="true"></i>
  </button>
}

@if (isVisible) {
  <div id="xact-float"
       class="xact-float"
       [class.xact-float--minimised]="isMinimised"
       [class.xact-float--large]="isLarge"
       cdkDrag
       cdkDragBoundary="#particle-main-content"
       [cdkDragFreeDragPosition]="dragPosition"
       (cdkDragEnded)="onDragEnded($event)"
       role="dialog"
       aria-label="Xact Playground">

    <!-- ─── The window. Hidden, not destroyed, while minimised: the script and its marks are work in progress. ─── -->
    <div class="xf-window" [hidden]="isMinimised">
      @if (bodyComponent) {
        <ng-container *ngComponentOutlet="bodyComponent"></ng-container>
      } @else {
        <!-- Until the lazy body arrives: the bar's shape, so the window can still be dragged and closed. -->
        <div class="xf-loading" cdkDragHandle>
          <span class="xf-loading-name">Xact</span>
          <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
          <span class="xf-spacer"></span>
          <button type="button" class="xf-icon" (click)="close()" title="Close" aria-label="Close the Xact Playground">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          </button>
        </div>
      }

      <!-- ─── This window's own run: the Action Monitor's run view, as a drawer over the editor. Every other run is the
           Action Monitor's to show (XAT-E-377-05). ─── -->
      @if (hostsRun) {
        <div class="xf-drawer" [class.xf-drawer--folded]="isDrawerFolded">
          <app-action-monitor-run-view class="xf-run" [embedded]="true">
            <button runViewChrome type="button" class="xf-icon" (click)="toggleDrawer()"
                    [title]="isDrawerFolded ? 'Show the steps' : 'Fold the run away'"
                    [attr.aria-label]="isDrawerFolded ? 'Show the steps' : 'Fold the run away'">
              <i class="fa-solid" [class.fa-chevron-up]="isDrawerFolded" [class.fa-chevron-down]="!isDrawerFolded" aria-hidden="true"></i>
            </button>
            @if (!isRunning) {
              <button runViewChrome type="button" class="xf-icon" (click)="dismissRun()"
                      title="Put this run away" aria-label="Put this run away">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
              </button>
            }
          </app-action-monitor-run-view>
        </div>
      }
    </div>
  </div>
}
